import produce from 'immer';
import { AnyAction } from 'redux';
import { RENEWAL_DASHBOARD_DATA } from '../actions';
import { AUTH_ACTIONS } from '../actions/auth';
import { RenewalDashboardState } from '../types/state';

const initialState: RenewalDashboardState = {};

const renewalDashboardReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case RENEWAL_DASHBOARD_DATA.SET_DATA: {
      return produce(state, (draftState) => {
        draftState.data = action.payload.data;
        draftState.startDate = action.payload.startDate;
        draftState.endDate = action.payload.endDate;
      });
    }
    case AUTH_ACTIONS.LOGOUT: {
      return initialState;
    }
    default:
      return state;
  }
};

export default renewalDashboardReducer;
